import format from "date-fns/format";
import { connect } from "react-redux";
import { Actions as ADMINACTIONS } from "../../store/actions/adminActions";

const PaymentHandlingRow = ({ client, currency, openModal }) => {
	return (
		<tr>
			<td className="text-left">{client?.senderName}</td>
			<td style={{ textAlign: "center" }}>
				{currency} {(client?.amount / 100).toFixed(2)}
			</td>
			{/* <td style={{textAlign: 'center'}}>
                {client?.iban}
            </td> */}
			<td style={{ textAlign: "center" }}>{format(new Date(client?.timestamp), "do MMM yyyy")}</td>
			{/* <td style={{textAlign: 'center'}}>
                {client?.status}
            </td>
            <td className="text-right">
                {client?.transactionNote}
            </td> */}
			<td>
				{/* Additionally, make only show when what's in the drop down is different to the default value */}
				{
					<button
						className="btn btn-xs btn-success pull-left"
						title="Review"
						style={{ marginLeft: "0.5rem" }}
						// onClick={() => { savePaymentHandleStatus({paymentHandleId: client.id, companyId: companyDropDown?.org, advisorId: companyDropDown?.advisor}) }}>
						onClick={() => {
							openModal({ client: client, modalStatus: true });
						}}
					>
						Review
					</button>
				}
			</td>
		</tr>
	);
};

const mapStateToProps = (state) => {
	return {
		currency: state.company?.settings?.currency,
	};
};

const mapDispatchToProps = (dispatch) => ({
	openModal: (payload) => dispatch(ADMINACTIONS.getPaymentHandleModal(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentHandlingRow);
